export default __webpack_public_path__ + "static/grandangolo-2-fc209c50678d5d21266ceddfe15cb120.jpg";